import { NgModule } from "@angular/core";
import { S25IconComponent } from "../../s25-icon/s25.icon.component";
import { S25IconButtonComponent } from "../../../standalone/s25.icon.button.component";
import { S25DocumentListComponent } from "./s25.document.list.component";
import { CommonModule } from "@angular/common";
import { S25TableModule } from "../../s25-table/s25.table.module";
import { S25EditDocumentComponent } from "./s25.edit.document.component";
import { FormsModule } from "@angular/forms";
import { S25LoadingInlineModule } from "../../s25-loading/s25.loading.inline.module";
import { S25RichTextEditorModule } from "../../s25-rich-text-editor/s25.rich.text.editor.module";
import { S25SimpleCollapseModule } from "../../s25-simple-collapse/s25.simple.collapse.module";
import { BpeModule } from "../../bpe/bpe.module";
import { S25DocumentReservationListComponent } from "./s25.document.reservation.list.component";
import { S25ModalModule } from "../../s25-modal/s25.modal.module";
import { S25DatepickerModule } from "../../s25-datepicker/s25.datepicker.module";
import { S25DropdownPaginatedModule } from "../../s25-dropdown/s25.dropdown.paginated.module";
import { S25PipesModule } from "../../../pipes/s25.pipes.module";
import { S25HelpDirective } from "../../s25-help/s25.help.directive";
import { S25DocumentInvoiceListComponent } from "./s25.document.invoice.list.component";
import { S25TabGroupComponent } from "../../../standalone/s25.tab.group.component";
import { S25ButtonComponent } from "../../../standalone/s25.button.component";
import { DocumentReportBuilderTableComponent } from "./s25.document.report.builder.table.component";
import { DocumentReportBuilderCellComponent } from "./s25.document.report.builder.cell.component";
import { DocumentReportBuilderComponent } from "./s25.document.report.builder.component";
import { DocumentReportBuilderCellEditorComponent } from "./s25.document.report.builder.cell.editor.component";
import { PopoverModule } from "../../s25-popover/popover.module";
import { CssRuleComponent } from "../../s25-styles/s25.css.rule.component";
import { S25InfoMessageModule } from "../../s25-info-message/s25.info.message.module";
import { ModalModule } from "../../modal/modal.module";
import { S25ImportDocumentComponent } from "./s25.import.document.component";
import { S25DocumentReportBuilderCellEditorFunctionComponent } from "./s25.document.report.builder.cell.editor.function.component";
import { S25ReportParametersComponent } from "./s25.report.parameters.component";
import { S25ToggleButtonModule } from "../../s25-toggle-button/s25.toggle.button.module";
import { S25CheckboxModule } from "../../s25-checkbox/s25.checkbox.module";
import { S25ImageModule } from "../../s25-image/s25.image.module";

@NgModule({
    imports: [
        CommonModule,
        S25TableModule,
        FormsModule,
        S25LoadingInlineModule,
        S25RichTextEditorModule,
        S25SimpleCollapseModule,
        BpeModule,
        S25ModalModule,
        S25DatepickerModule,
        S25DropdownPaginatedModule,
        S25PipesModule,
        S25HelpDirective,
        S25TabGroupComponent,
        S25ButtonComponent,
        PopoverModule,
        S25IconComponent,
        S25IconButtonComponent,
        CssRuleComponent,
        S25InfoMessageModule,
        ModalModule,
        S25ImportDocumentComponent,
        S25DocumentReportBuilderCellEditorFunctionComponent,
        S25ToggleButtonModule,
        S25CheckboxModule,
        S25ImageModule,
    ],
    declarations: [
        S25DocumentListComponent,
        S25EditDocumentComponent,
        S25DocumentReservationListComponent,
        S25DocumentInvoiceListComponent,
        DocumentReportBuilderComponent,
        DocumentReportBuilderTableComponent,
        DocumentReportBuilderCellComponent,
        DocumentReportBuilderCellEditorComponent,
        S25ReportParametersComponent,
    ],
    exports: [
        S25DocumentListComponent,
        S25EditDocumentComponent,
        S25DocumentReservationListComponent,
        S25DocumentInvoiceListComponent,
    ],
    providers: [
        S25DocumentListComponent,
        S25EditDocumentComponent,
        S25DocumentReservationListComponent,
        S25DocumentInvoiceListComponent,
    ],
})
export class S25DocumentManagementModule {}
